import React from 'react';

function LoadingScreen() {
    return (
        <div className="min-h-screen bg-black flex items-center justify-center">
            <div className="text-center">
                <div className="w-16 h-16 border-4 border-pink-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                <h2 className="text-2xl text-white font-semibold">Loading...</h2>
            </div>
        </div>
    );
}

export default LoadingScreen;